import { getFormattedDate } from '../helpers/dateTimeHelpers';

export function getDecodedQueryString() {
    const {
        location: { search = '' } = {},
        decodeURIComponent = i => i
    } = global;

    return search
        .substring(1)
        .split('&')
        .reduce((o, pair) => {
            const [key, value = ''] = pair.split('=');

            if (key) {
                return {
                    ...o,
                    [key]: decodeURIComponent(value.replace(/\+/g, '%20'))
                };
            }

            return o;
        }, {});
}

export const getTermsText = startDate => {
    if (!startDate) {
        return 'Opening times may be subject to change. ';
    }

    const termsTime = getFormattedDate(startDate, 'h:mma');
    const termsDate = getFormattedDate(startDate, 'DD.MM.YYYY');

    return `Entries Until ${termsTime} on ${termsDate}, `;
};
